import gql from 'graphql-tag'

const updateManyProductPrices = gql`
mutation updateManyProductPrices($idArr: [ID]! $updateValues: [NewProductPrice!]!){
	cashAssist {
		updateManyProductPrices(idArr: $idArr, updateValues: $updateValues) {
            id
		}
	}
}`

export default updateManyProductPrices
